/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';

class ModalTemplateExample extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center',
      closeButton: true,
      keyboard: true,
    });
  }

  render() {
    return (
      <ModalBaseLayout {...this.settings}>
        <div className="">!!!!!!!!!!!!!Modal content example</div>
      </ModalBaseLayout>
    );
  }
}

ModalTemplateExample.propTypes = {};

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalHide} from '../../../store/actions/actions-modal';

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalTemplateExample);
